import ufeApi from 'services/api/ufeApi';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const path = '/gway/v1/p13n/puwlo/batch';

function normalizeCard(card) {
    if (!card) {
        return null;
    }

    return {
        contextId: card.contextId,
        cardType: card.cardType,
        displayOrder: card.display_order,
        title: card.title,
        clickAction: card.clickAction,
        products: Array.isArray(card.products) ? card.products : [],
        abTest: card.abTest,
        caching: card.caching
    };
}

function normalizeBatchResponse(responseData) {
    const data = responseData || {};
    const cards = Array.isArray(data.cards) ? data.cards.map(normalizeCard).filter(Boolean) : [];

    return {
        cards,
        excludedCards: Array.isArray(data.excludedCards) ? data.excludedCards : [],
        meta: data.meta
    };
}

async function getP13nPuwylosBatchData({
    contextIds, userId, locale, constructorClientId, constructorSessionId
}) {
    const apikey = Sephora.configurationSettings.sdnUfeAPIUserKey;

    const rvDataRaw = Storage.local.getItem('rvData') || [];
    const recentlyViewedSkuIds = (Array.isArray(rvDataRaw) ? rvDataRaw : []).map(item => item.skuId || item.sku_id).filter(Boolean);

    const rvCategoryDataRaw = Storage.local.getItem(LOCAL_STORAGE.RV_CATEGORY_DATA) || [];
    const recentlyViewedCategoryIds = Array.isArray(rvCategoryDataRaw) ? rvCategoryDataRaw : [];

    const requestBody = {
        contextIds,
        userId,
        channel: 'web',
        locale,
        atgId: userId,
        ...(constructorClientId && { constructorClientId }),
        ...(constructorSessionId && { constructorSessionId }),
        ...(recentlyViewedSkuIds.length > 0 && { recentlyViewedSkuIds }),
        ...(recentlyViewedCategoryIds.length > 0 && { recentlyViewedCategoryIds })
    };

    try {
        const response = await ufeApi.makeRequest(path, {
            method: 'POST',
            headers: {
                'x-api-key': apikey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestBody)
        });

        const { data, errorCode, message, error } = response || {};

        if (errorCode || error) {
            const errorMessage = message || error?.message || 'Unknown';
            Sephora.logger.warn(`PUWYLO BATCH: API error - ${errorMessage}`);

            return null;
        }

        // The batch payload is returned wrapped in a `data` envelope (`{ data: { cards } }`).
        return normalizeBatchResponse(data);
    } catch (error) {
        Sephora.logger.error('PUWYLO BATCH: Failed to fetch batch data', error);

        return null;
    }
}

export default getP13nPuwylosBatchData;
